import { render, staticRenderFns } from "./UserMessage.vue?vue&type=template&id=2e5edd86&scoped=true"
import script from "./UserMessage.vue?vue&type=script&lang=js"
export * from "./UserMessage.vue?vue&type=script&lang=js"
import style0 from "./UserMessage.vue?vue&type=style&index=0&id=2e5edd86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5edd86",
  null
  
)

export default component.exports